export default __webpack_public_path__ + "static/media/AngelaChaney.62c2934a.jpg";